const initTabs = ()=> {

    // console.log("tabs.js");

    const tabsNavLinks = document.querySelectorAll('.tabs__nav_link');

    tabsNavLinks.forEach(btn => {
        btn.addEventListener('click', () => {

            const nav = btn.closest('[data-target-tabs]');
            if (!nav) return;

            const tabsGroupSelector = nav.dataset.targetTabs;
            const tabsGroup = document.getElementById(tabsGroupSelector);
            if (!tabsGroup) return;

            const groupButtons = nav.querySelectorAll('.tabs__nav_link');
            // const groupPanes = tabsGroup.querySelectorAll('.tab__pane');

            groupButtons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            const target = tabsGroup.querySelector(btn.dataset.target);
            if (!target) return;

            const activePane = tabsGroup.querySelector('.tab__pane.active');

            if (activePane) {
                activePane.classList.remove('show');
                activePane.classList.remove('active');
            }

            target.classList.add('active');
            requestAnimationFrame(() => target.classList.add('show'));
        });
    });

}

export default initTabs;
